import React, {useEffect, useState} from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Spinner } from "../components";
import { getUser } from "../api";

const PrivateRoute = ({ children }) => {
  const [auth, setAuth] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const validateToken = async () => {
      try {

        const response = await getUser();

        if (response.ok) {
          setAuth(true);

        } else {
          setAuth(false);
          localStorage.removeItem('token');
          navigate("/login", {replace: true});
        }

      } catch (error) {
        setAuth(false);
        localStorage.removeItem('token');
        navigate("/login", {replace: true});
      }
    };

    validateToken();
  }, [navigate, location]);

  if (auth === null) {
    return <Spinner />;
  }

  return children; 
}

export default PrivateRoute;
